import { Col, Row, Skeleton, Typography } from "@commonlibs";
import clsx from "clsx";
import { useGetUserInfo } from "features/users/hooks/useGetUserInfo";
import { UserType } from "domain/user/UserType";
import useTranslate from "ui/locale/hooks/useTranslate";
import useGetBalance from "ui/wallet/query/useGetBalance";
import PointsBalance from "../PointsBalance/PointsBalance";
import { useGetPointCaducity } from "features/token/hooks/useGetPointCaducity";
import FiatBalance from "../FiatBalance/FiatBalance";
import useFormatDate from "ui/common/hooks/useFormatDate/useFormatDate";

export interface AccountCardDetailProps {
    className?: string;
    style?: React.CSSProperties;
}

function AccountCardDetail({ className, ...rest }: AccountCardDetailProps) {
    const { data: balance = "0", isLoading: isLoadingBalance } = useGetBalance();
    const { data: caducity, isLoading: isLoadingCaducity } = useGetPointCaducity();
    const { data: user, isLoading: isLoadingUserInfo } = useGetUserInfo();
    const isLoading = isLoadingCaducity && isLoadingBalance && isLoadingUserInfo;
    const translate = useTranslate();
    const formatDate = useFormatDate("slashed");

    const date = new Date(caducity?.expirationDate || Date.now());

    const greetUserName = user?.type === UserType.commercial ? user?.companyName : user?.name;

    return (
        <Col className={clsx("account-card-header", className)} alignItems="start" justifyContent="space-between" {...rest}>
            <Skeleton loading={isLoading}>
                <Row wrap gap={5}>
                    <Typography variant="body1Strong" color="white" numberOfLines={1}>
                        {translate("welcome")} {greetUserName?.upperFirst()},
                    </Typography>
                    <Typography variant="body1Strong" color="white" numberOfLines={1}>
                        {translate("havePoints")}{" "}
                        <PointsBalance
                            balance={balance}
                            variant="body1Strong"
                            color="gray.0"
                            style={{
                                display: "inline",
                            }}
                            isLoading={isLoading}
                        />
                    </Typography>
                </Row>
                <Col>
                    <Typography variant="body4Regular" color="overlays.0.60" numberOfLines={1}>
                        Equivalen a{" "}
                        <FiatBalance
                            balance={balance}
                            variant="body4Regular"
                            color="overlays.0.60"
                            style={{
                                display: "inline",
                            }}
                            isLoading={isLoading}
                        />
                    </Typography>
                    {caducity && BigInt(balance) > BigInt("0") && (
                        <Typography variant="body5Regular" color="overlays.0.60" numberOfLines={1}>
                            <PointsBalance
                                balance={balance}
                                variant="body5Regular"
                                color="overlays.0.60"
                                style={{
                                    display: "inline",
                                }}
                            />
                            &nbsp;
                            {translate("pointsCaducityText", { date: formatDate(date) })}
                        </Typography>
                    )}
                </Col>
            </Skeleton>
        </Col>
    );
}

export default AccountCardDetail;
